var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldCardPos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.25 22H2.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h18.5c.41 0 .75.34.75.75s-.34.75-.75.75zM4.651 15.262c-.41.41-1.07.41-1.47 0h-.01a3.58 3.58 0 0 1 0-5.05l7.15-7.15c1.4-1.4 3.66-1.4 5.06 0 .41.39.41 1.06.01 1.46l-10.74 10.74z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.771 5.44c-.41-.41-1.07-.41-1.47 0L5.561 16.18c-.41.4-.41 1.06 0 1.47l3.05 3.06a3.591 3.591 0 0 0 5.06 0l7.14-7.15c1.42-1.4 1.42-3.67.01-5.07l-3.05-3.05zm-6.22 13.3c-.25.25-.66.25-.92 0a.658.658 0 0 1 0-.92l1.22-1.22c.24-.24.66-.24.91 0 .25.25.25.68 0 .92l-1.21 1.22zm2.74-2.74c-.25.24-.66.24-.92 0a.658.658 0 0 1 0-.92l2.45-2.45c.24-.24.66-.24.91 0 .25.26.25.67 0 .92L14.291 16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldCardPos);
export default __webpack_public_path__ + "static/media/vuesax-bold-card-pos.fc882053f51b5d8d9629268563f4cb27.svg";
export { ForwardRef as ReactComponent };